import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "errorBox", "form"]
  connect() {
    console.log("Modal controller connected!");
  }

  open() {
    this.modalTarget.classList.add("is-visible")
  }

  close(event) {
    if (event.target === this.modalTarget || event.target.classList.contains("c-button--close")) {
      this.modalTarget.classList.remove("is-visible")
      this.clearErrors()
    }
  }

  showErrors(event) {
    const [data, _status, _xhr] = event.detail
    const messages = data.errors || ["Errore generico, riprova."]

    this.errorBoxTarget.innerHTML = `
      <ul>
        ${messages.map(msg => `<li>${msg}</li>`).join("")}
      </ul>
    `
    this.errorBoxTarget.hidden = false
  }

  clearErrors() {
    if (this.hasErrorBoxTarget) {
      this.errorBoxTarget.hidden = true
      this.errorBoxTarget.innerHTML = ""
    }
  }
}
